import { render, staticRenderFns } from "./CabonCostByScope.vue?vue&type=template&id=f353bad4"
import script from "./CabonCostByScope.vue?vue&type=script&lang=js"
export * from "./CabonCostByScope.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports